import { render } from "./CustomMap.vue?vue&type=template&id=6ec0b67a"
import script from "./CustomMap.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomMap.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/scada/map/CustomMap.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ec0b67a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ec0b67a', __exports__)) {
    console.log('reload')
    api.reload('6ec0b67a', __exports__)
  }
  
  module.hot.accept("./CustomMap.vue?vue&type=template&id=6ec0b67a", () => {
    console.log('re-render')
    api.rerender('6ec0b67a', render)
  })

}


export default __exports__